import { convertDateToEpoch } from "../../../../helper/DateConverters";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import axios from "../../../../util/axiosconfig";
import { showError, showSuccess } from "../../../../util/ShowStatus";

export const extendTimeSheet = async (
  extendTimeSheetData: any,
  setExtendTimeSheetData: any,
  setShowExtendedTimesheet: any,
  setExtendTimeSheetWeek: any,
  setExtendTimeSheetFormErrors: any,
  setAddExtendTimeSheetLoading: any,
  toast: any
) => {
  try {
    setAddExtendTimeSheetLoading(true);
    const params: any = {};
    if (extendTimeSheetData.userID) {
      params.userID = extendTimeSheetData.userID;
    }
    if (extendTimeSheetData.startDate) {
      params.startDate = convertDateToEpoch(extendTimeSheetData.startDate);
    }
    if (extendTimeSheetData.endDate) {
      params.endDate = convertDateToEpoch(extendTimeSheetData.endDate);
    }

    // if (extendTimeSheetData.extendHours) {
    //   const endDateObj = new Date(extendTimeSheetData.endDate);
    //   let extendedEndDate = new Date(endDateObj);

    //   // 0 = Sunday, 1 = Monday
    //   if (endDateObj.getDay() === 0) {
    //   // If Sunday, move to next day (Monday)
    //   extendedEndDate.setDate(endDateObj.getDate() + 1);
    //   } else if (endDateObj.getDay() === 1) {
    //   // If Monday, keep as is
    //   extendedEndDate = new Date(endDateObj);
    //   }

    //   extendedEndDate.setHours(
    //   17 + Math.floor(extendTimeSheetData.extendHours),
    //   (extendTimeSheetData.extendHours % 1) * 60,
    //   0,
    //   0
    //   ); // Add extended hours after 5 PM

    //   params.expiryTime = extendedEndDate.getTime();
    // }

      if (extendTimeSheetData.extendHours) {
        const endDateObj = new Date(extendTimeSheetData.endDate);
        const extendedEndDate = new Date(endDateObj);
        extendedEndDate.setUTCDate(endDateObj.getUTCDate() + 1); // Move to next Monday (UTC)
        extendedEndDate.setUTCHours(
        17 + Math.floor(extendTimeSheetData.extendHours),
        (extendTimeSheetData.extendHours % 1) * 60,
        0,
        0
        ); // Add extended hours after 5 PM UTC
        params.expiryTime = extendedEndDate.getTime();
      }

    // {
    //     "userID":46,
    //     "startDate":1741545000,
    //     "endDate":1741545000,
    //     "expiryTime":1741545000
    // }

    const response = await axios.post("tl-user/extend-time-sheets", params);
    const currentDate = new Date();
    const currentDay = currentDate.getDay();
    const monday = new Date(currentDate);
    monday.setDate(
      currentDate.getDate() - (currentDay === 0 ? 6 : currentDay - 1)
    ); // Adjust to Monday
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6); // Adjust to Sunday
    monday.setHours(0, 0, 0, 0);
    sunday.setHours(23, 59, 59, 999);
    setExtendTimeSheetWeek([monday, sunday]);
    setExtendTimeSheetData({
      name: null,
      userID: null,
      startDate: monday,
      endDate: sunday,
      extendHours: null,
    });
    setExtendTimeSheetFormErrors({
      name: null,
      startDate: null,
      endDate: null,
      extendHours: null,
    });
    showSuccess(
      response?.data?.result?.message ??
        "Time log extended for user successfully",
      toast
    );
    setShowExtendedTimesheet(false);
    setAddExtendTimeSheetLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setAddExtendTimeSheetLoading(false);
    showError(error, toast);
  }
};
